import { FlyIn, IconButton, OverlayLoader } from '@coop/components';
import { MenuIcon } from '@coop/icons';
import * as React from 'react';

import type { SiteNavigationItem } from './FeaturedNavigation';

import useModal from '../../../common/hooks/useModal';
import { FlyInType } from '../../../common/store/structureDefinitions/modalState';
import { useIsDarkMode } from '../../../ecommerce/hooks/useIsDarkMode';

const SiteNavigation = React.lazy(() => import('../SiteNavigation'));

interface HeaderLeftNavProps {
    disableSiteNavigation: boolean;
    navigationItems: SiteNavigationItem[];
}

const HeaderLeftNav = (props: React.PropsWithChildren<HeaderLeftNavProps>) => {
    const { isOpen, close, open } = useModal(FlyInType.SiteNavigation);

    const isDarkMode = useIsDarkMode();

    return (
        !props.disableSiteNavigation && (
            <nav aria-label="Huvudmeny">
                <FlyIn.Root
                    isOpen={isOpen}
                    close={close}
                    sizePx={375}
                    alignment="left"
                    initialFocusOnDialog={false}
                    renderTrigger={(ref) => (
                        <IconButton
                            ref={ref}
                            icon={<MenuIcon />}
                            label="Meny"
                            onClick={open}
                            theme={isDarkMode ? 'outlined-inverse' : 'outlined-subtle'}
                        />
                    )}
                >
                    <React.Suspense fallback={<OverlayLoader isLoading />}>
                        <SiteNavigation onClose={close} />
                    </React.Suspense>
                </FlyIn.Root>
            </nav>
        )
    );
};

export default HeaderLeftNav;
